import React, { FunctionComponent } from 'react'
import { Accordion, ContentCard } from '../../../components/integration-builder'
import { AcceptCards, AcceptPayments } from '../../../components/icons'

import { Tooltip, Row, Col } from '@paypalcorp/pp-react'
import styles from '../integration-builder.module.css'

const StandardTooltip = (
  <Tooltip
    name="tooltip-for-standard"
    description="PayPal payments are presented with PayPal-branded buttons and payment is processed through the PayPal back-end."
    windowId="window1"
  />
)
const AdvanceTooltip = (
  <Tooltip
    name="tooltip-for-advance"
    description="Requires a merchant account and approval for hosted checkout functionality."
    windowId="window1"
  />
)

const KBYC: FunctionComponent = () => {
  return (
    <div className={styles.checkout_simulator__card_wrapper}>
      <Accordion
        color="primary"
        heading={
          <h1 className={styles.checkout_simulator__head_title}>
            Know before you code
          </h1>
        }
        content={
          <div className={styles.checkout_simulator__cards_wrapper}>
            <Row>
              <Col sm={12} md={6}>
                <ContentCard
                  icon={<AcceptPayments width="36" height="36" />}
                  badgeType="feature"
                  badgeText="PayPal"
                  content={
                    <>
                      <span className={styles.checkout_simulator__card_title}>
                        PayPal Checkout
                      </span>
                      <span className={styles.integration_builder__tooltip}>
                        {StandardTooltip}
                      </span>
                      <span className={styles.checkout_simulator__card_title}>
                        allows you to offer a variety of payment options:
                      </span>
                      <ul className={styles.checkout_simulator__card_content}>
                        <li>PayPal</li>
                        <li>Pay Later</li>
                        <li>Venmo</li>
                        <li>
                          Debit and Credit through a PayPal-managed guest
                          checkout
                        </li>
                      </ul>
                    </>
                  }
                />
              </Col>
              <Col sm={12} md={6}>
                <ContentCard
                  icon={<AcceptCards width="44" height="28" />}
                  badgeType="feature"
                  badgeText="Expanded"
                  content={
                    <>
                      <span className={styles.checkout_simulator__card_title}>
                        CExpanded Checkout
                      </span>
                      <span className={styles.integration_builder__tooltip}>
                        {AdvanceTooltip}
                      </span>
                      <span className={styles.checkout_simulator__card_title}>
                        allows you to accept all of the PayPal Checkout payment
                        types as well as:
                      </span>
                      <ul className={styles.checkout_simulator__card_content}>
                        <li>Direct Debit and Credit card processing</li>
                        <li>Customizable Payment Protection</li>
                        <li>
                          Unbranded checkout, with customizable buttons and form
                          fields
                        </li>
                        <li>Region-specific alternative payments methods</li>
                      </ul>
                    </>
                  }
                />
              </Col>
            </Row>
          </div>
        }
      />
    </div>
  )
}

export default KBYC
